/**
 * LegacyKernelCompat - 老内核浏览器 antd 样式降级兼容
 *
 * antd 6 的 cssinjs 默认给每条组件样式规则加 `:where(.css-hash)` 前缀，
 * Chromium < 88 的老内核（QQ 浏览器 10.x、360 安全浏览器 13 等，Win7/XP 存量设备）
 * 不支持 `:where()` 选择器，会把整条规则丢弃，表现为 antd 样式整体失效
 * （弹层丢失绝对定位掉到页面底部、表单内边距丢失等；页面残余样式来自自有 scss 覆盖）。
 *
 * 检测到不支持 `:where()` 时启用 antd 官方降级方案：
 * - hashPriority="high"：去掉 `:where()` 前缀（代价是 antd 规则选择器优先级升高，
 *   可能压过部分同优先级的 scss 覆盖——仅老内核受影响，远好于样式全灭）
 * - legacyLogicalPropertiesTransformer：把 padding-inline / inset-inline 等
 *   逻辑属性转为物理属性（Chromium < 87 不支持逻辑属性简写）
 *
 * 现代浏览器不做任何包裹，样式产出与未接入前完全一致。
 */
import React from 'react'
import {
  StyleProvider,
  legacyLogicalPropertiesTransformer
} from '@ant-design/cssinjs'

// CSS.supports 的 selector() 语法 Chrome 83 起支持；更老的内核对该查询返回 false，
// 同样会正确落入降级分支
const needsLegacyCompat =
  typeof CSS === 'undefined' ||
  typeof CSS.supports !== 'function' ||
  !CSS.supports('selector(:where(a))')

interface LegacyKernelCompatProps {
  children: React.ReactNode
}

function LegacyKernelCompat({ children }: LegacyKernelCompatProps) {
  if (!needsLegacyCompat) {
    return <>{children}</>
  }
  return (
    <StyleProvider
      hashPriority="high"
      transformers={[legacyLogicalPropertiesTransformer]}
    >
      {children}
    </StyleProvider>
  )
}

export default LegacyKernelCompat
